import React from 'react';
import styled from 'styled-components';

import CourseOptions from './CourseOptions';
import shortid from 'shortid';
import RemoveIcon from 'images/RemoveIcon';

export const SelectedCourseList = props =>  {
    
    const { courses, period, options, allCourses, selectedCourses } = props;
    
    return (
        <Wrapper>
            { courses.length > 0 ? courses.map((course, i) => {
                const id = shortid.generate();
                let allYear = course.name.includes('helår'); 
                let fall = course.name.includes('høst');
                let spring = course.name.includes('vår');
                allCourses.forEach(courseToCheck => {
                    if(courseToCheck !== course && courseToCheck.name.split('(', 1)[0] === course.name.split('(', 1)[0]){
                        if(courseToCheck.name.includes('helår')) allYear = true;
                        if(courseToCheck.name.includes('høst')) fall = true;
                        if(courseToCheck.name.includes('vår')) spring = true; 
                    }
                }); 
                return (
                    <Course key={id} inSeason={(course.value.acf.period === "Helår" && period === "Høst") || period === course.value.acf.period}>
                        <NameAndOptions>
                            <CourseName>{course.name}</CourseName>
                            <CourseOptions options={options} course={course} handleOptionChange={props.handleToggleOption} selectedCourses={selectedCourses} />
                        </NameAndOptions>
        
                        <SeasonsAndRemove>
                            <Season period={course.value.acf.period} />
                            <Season>
                                {allYear &&
                                    <StyledP active={course.name.includes('helår')} onClick={() => props.handleTermChange(course, "helår")}>
                                        Helår
                                    </StyledP>
                                }
                                {(allYear && (fall || spring)) &&
                                    <p>/</p>
                                }

                                {fall &&
                                    <StyledP active={course.name.includes('høst')} onClick={() => props.handleTermChange(course, "høst")}>
                                        {!allYear ? 'Høst' : 'høst'}
                                    </StyledP>
                                }
                                {(fall && spring) &&
                                    <p>/</p>
                                }

                                {spring &&
                                    <StyledP active={course.name.includes('vår')} onClick={() => props.handleTermChange(course, "vår")}>
                                        {(!allYear && !spring) ? 'Vår' : 'vår'}
                                    </StyledP>
                                }
                            </Season>
                            <RemoveIcon color="#fff" onClick={() => props.removeCourse(course)} />
                        </SeasonsAndRemove>
                    </Course>
                )
            }) : null}
        </Wrapper>
    )
}

export default SelectedCourseList;

const Wrapper = styled.div`
    margin-bottom: 20px;
    @media(max-width: 767px){
        margin-bottom: 0;
    }
`

const Course = styled.div`
    display: flex;
    justify-content: space-between; 
    opacity: ${props => props.inSeason ? 1 : .4};

    p {
        margin-right: 6px;
        color: #fff;
    }  

    svg{
        cursor: pointer; 
        margin-top: 6px; 
        margin-left: 6px; 
    }

    p{
        margin-right: 4px; 
        text-overflow: ellipsis;
        overflow: hidden; 
        white-space: nowrap; 
    }
    margin-bottom: 5px;
    &:last-child{
        margin-bottom: 10px; 
    }
`

const Season = styled.div`
    display: flex;

    p {
        color: #fff;
    }
`

const StyledP = styled.p`
    text-decoration: ${props => props.active ? 'underline' : 'none'};
    cursor: pointer;

`

const SeasonsAndRemove = styled.div`
    display: flex; 
`

const CourseName = styled.p`
    min-width: 160px; 
    width: 160px; 
`

const NameAndOptions = styled.div`
    display: flex; 
`


// WEBPACK FOOTER //
// ./src/partials/modules/TimePlanNew/courseSelect/SelectedCourseList.js